import { useEmojis } from "./useEmojis"

const emojiNames = ["heart", "pray", "laughing", "+1", "-1"]

export const useReactions = () => useEmojis(emojiNames)
